<aside
  class="ap apsb fixed top-0 left-0 h-screen z-[var(--ap-z-drawer)] transition-all duration-300"
  [class.w-64]="sidebarOpen"
  [class.w-16]="!sidebarOpen"
  [class.-translate-x-full]="!sidebarOpen && !isLargeScreen"
  [class.translate-x-0]="sidebarOpen || isLargeScreen"
  [class.apsb--collapsed]="!sidebarOpen"
  [attr.aria-label]="'sidebar.primaryNav' | translate"
>
  <div class="apsb__inner">
    <!-- Account block (profile page hidden for now — non-interactive identity) -->
    <div class="apsb__user" [title]="(user$ | async)?.email || ''">
      <span class="apsb__avatar" aria-hidden="true">
        @if ($any(profile$ | async)?.avatar_url; as avatar) {
          <img [src]="avatar" alt="" />
        } @else {
          {{ initials((profile$ | async)?.fullname, (user$ | async)?.email) }}
        }
      </span>
      <span class="apsb__userinfo">
        <span class="apsb__name">{{ (profile$ | async)?.fullname || ('sidebar.member' | translate) }}</span>
        <span class="apsb__email">{{ (user$ | async)?.email }}</span>
      </span>
    </div>

    <nav class="apsb__nav">
      <!-- You -->
      <div class="apsb__group">
        <span class="apsb__grouplabel">{{ 'sidebar.you' | translate }}</span>
        <a routerLink="/dashboard" routerLinkActive="is-active" (click)="closeSidebar()" class="apsb__item" [title]="'sidebar.home' | translate">
          <svg class="apsb__ico" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 11.5 12 5l8 6.5M6 10v9h12v-9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <span class="apsb__label">{{ 'sidebar.home' | translate }}</span>
        </a>
        <a routerLink="/favorites" routerLinkActive="is-active" (click)="closeSidebar()" class="apsb__item" [title]="'sidebar.favorites' | translate">
          <svg class="apsb__ico" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 20s-7-4.35-7-9.5A4.5 4.5 0 0 1 12 7a4.5 4.5 0 0 1 7 3.5C19 15.65 12 20 12 20Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>
          <span class="apsb__label">{{ 'sidebar.favorites' | translate }}</span>
        </a>
        <a routerLink="/requests" routerLinkActive="is-active" (click)="closeSidebar()" class="apsb__item" [title]="'sidebar.myRequests' | translate">
          <svg class="apsb__ico" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5h9a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><rect x="9" y="3" width="6" height="4" rx="1" stroke="currentColor" stroke-width="1.7"/><path d="m8.5 12 2 2 3.5-3.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <span class="apsb__label">{{ 'sidebar.myRequests' | translate }}</span>
        </a>
      </div>

      <!-- Discover hidden for now (route still live); un-comment to restore
      <div class="apsb__group">
        <span class="apsb__grouplabel">{{ 'sidebar.discover' | translate }}</span>
        <a routerLink="/discover" routerLinkActive="is-active" (click)="closeSidebar()" class="apsb__item" [title]="'sidebar.allClubs' | translate">
          <svg class="apsb__ico" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.8"/><path d="m20 20-3.2-3.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
          <span class="apsb__label">{{ 'sidebar.allClubs' | translate }}</span>
        </a>
      </div>
      -->

      <!-- Resume the wizard: owner signed up but never created the listing -->
      @if (needsListingSetup$ | async) {
        <div class="apsb__group">
          <span class="apsb__grouplabel">{{ 'sidebar.manage' | translate }}</span>
          <a routerLink="/setup/start" routerLinkActive="is-active" (click)="closeSidebar()" class="apsb__item apsb__item--accent" [title]="'sidebar.completeListing' | translate">
            <svg class="apsb__ico" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 11.5 12 5l8 6.5M6 10v9h12v-9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 12.5v4M10 14.5h4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
            <span class="apsb__label">{{ 'sidebar.completeListing' | translate }}</span>
          </a>
        </div>
      }

      <!-- Manage (owners/admins only) -->
      @if (isClubOwnerOrAdmin$ | async) {
        <div class="apsb__group">
          <span class="apsb__grouplabel">{{ 'sidebar.manage' | translate }}</span>
          <a
            [routerLink]="clubIds.length > 1 ? ['/club-selection'] : ['/club', clubIds[0], 'stats']"
            [queryParams]="clubIds.length > 1 ? { to: 'stats' } : null"
            routerLinkActive="is-active"
            (click)="closeSidebar()"
            class="apsb__item"
            [title]="'sidebar.stats' | translate"
          >
            <svg class="apsb__ico" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 20h16M7 20v-7M12 20V8M17 20v-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
            <span class="apsb__label">{{ 'sidebar.stats' | translate }}</span>
          </a>
          <a
            [routerLink]="clubIds.length > 1 ? ['/club-selection'] : ['/club', clubIds[0], 'requests']"
            [queryParams]="clubIds.length > 1 ? { to: 'requests' } : null"
            routerLinkActive="is-active"
            (click)="closeSidebar()"
            class="apsb__item"
            [title]="'sidebar.visitRequests' | translate"
          >
            <svg class="apsb__ico" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 4h16v12H5.2L4 17.2V4z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><path d="M8 9h8M8 12h5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>
            <span class="apsb__label">{{ 'sidebar.requests' | translate }}</span>
          </a>
          <a
            [routerLink]="clubIds.length > 1 ? ['/club-selection'] : ['/club', clubIds[0], 'settings']"
            [queryParams]="clubIds.length > 1 ? { to: 'settings' } : null"
            routerLinkActive="is-active"
            (click)="closeSidebar()"
            class="apsb__item"
            [title]="'sidebar.clubSettings' | translate"
          >
            <svg class="apsb__ico" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M19 21V5a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v16M3 21h18M9 7h1m4 0h1M9 11h1m4 0h1M10 21v-4h4v4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
            <span class="apsb__label">{{ 'sidebar.clubSettings' | translate }}</span>
          </a>
        </div>
      }
    </nav>

    <!-- Bottom -->
    <div class="apsb__foot">
      <a routerLink="/settings" routerLinkActive="is-active" (click)="closeSidebar()" class="apsb__item" [title]="'sidebar.settings' | translate">
        <svg class="apsb__ico" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.7"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span class="apsb__label">{{ 'sidebar.settings' | translate }}</span>
      </a>
      <button type="button" (click)="signOut()" class="apsb__item apsb__signout" [title]="'sidebar.signOut' | translate">
        <svg class="apsb__ico" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 12H4m0 0 3.5-3.5M4 12l3.5 3.5M14 6V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span class="apsb__label">{{ 'sidebar.signOut' | translate }}</span>
      </button>
    </div>
  </div>
</aside>

<div
  *ngIf="sidebarOpen && !isLargeScreen"
  (click)="closeSidebar()"
  class="apsb__overlay"
  aria-hidden="true"
></div>
